module.exports = __webpack_public_path__ + "static/media/shieldIcon.9e246685.svg";